import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { UserRole } from '@utils/types/users/roles.ts';

export type UpdateUserData = {
  first_name: string;
  last_name: string;
  email: string;
  roles: UserRole[];
  id?: number;
};

export type UpdateUserPayload = Omit<UpdateUserData, 'email' | 'id'>;

export const useUpdateUser = () => {
  const queryClient = useQueryClient();

  const updateUser = async ({
    userId,
    userData
  }: {
    userId: string;
    userData: UpdateUserPayload;
  }): Promise<void> => {
    await Axios.patch(PUT_URL(userId).updateUser, userData);
  };

  return useMutation<
    void,
    AxiosError<BaseError>,
    { userId: string; userData: UpdateUserPayload }
  >(({ userId, userData }) => updateUser({ userId, userData }), {
    onSuccess: () => {
      queryClient.invalidateQueries(['users']);
    },
    useErrorBoundary: false
  });
};
